
import {ApplicationConfig, inject, LOCALE_ID, provideAppInitializer} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import {provideHttpClient, withInterceptors} from '@angular/common/http';

import { appRoutes } from './app.routes';

import { registerLocaleData } from '@angular/common';
import localeHr from '@angular/common/locales/hr';
registerLocaleData(localeHr);


import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import 'moment/locale/hr';
import {AuthService} from "./auth/auth.service";
import {catchError, from, of, switchMap} from "rxjs";

export const HR_DATE_FORMATS = {
    parse: { dateInput: 'DD.MM.YYYY' },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

// ⇩ Backend API prefixi koje želimo tretirati kao zaštićene
const API_HOSTS = [
    '/api',
    'http://localhost:8080/api',
    'http://127.0.0.1:8080/api',
];
const isApiRequest = (url: string) => API_HOSTS.some(p => url.startsWith(p));

export const appConfig: ApplicationConfig = {
    providers: [
        provideAnimations(),
        provideAppInitializer(() => inject(AuthService).init()),
        provideHttpClient(),
        provideRouter(appRoutes),
        provideHttpClient(
            withInterceptors([
                (req, next) => {
                    const auth = inject(AuthService);

                    if (!auth.isAuthenticated()) {
                        // ako nije logiran, ne šalji Authorization header
                        return next(req).pipe(
                            catchError(err => { throw err; })
                        );
                    }

                    // ako je logiran, uzmi token i dodaj ga
                    return from(auth.getToken()).pipe(
                        catchError(() => of('')),
                        switchMap(token => {
                            if (token) {
                                req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
                            }
                            return next(req);
                        }),
                        catchError(err => { throw err; })
                    );
                }
            ])
        ),

        { provide: LOCALE_ID, useValue: 'hr' },
        { provide: MAT_DATE_LOCALE, useValue: 'hr' },

        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } },

        { provide: MAT_DATE_FORMATS, useValue: HR_DATE_FORMATS },
    ],
};
